import { AxiosResponse } from "axios";
import { useContext, useRef, useState } from "react";
import { AdminFrame } from "views/common/AdminFrame";
import { postApiDataWithToken } from "views/utils/CallApi";
import * as mb from "views/common/MessageBox";
import { getRef } from "views/utils/InputHelp";
import * as Validation from "views/utils/Validation";
import { CtxAuth } from "views/utils/Contexts";

export function Password(): JSX.Element{

    const cua = useContext(CtxAuth);
    const [msgArgs, setMsgArgs] = useState({type:"", text:""});
    const currentPw = useRef<HTMLInputElement>(null);
    const newPw = useRef<HTMLInputElement>(null);
    const confirmPw = useRef<HTMLInputElement>(null);
    const [submitDisabled, setSubmitDisabled] = useState<boolean>(false);
    
    function clickSubmit(){

        setSubmitDisabled(true);

        //バリデーションチェック
        let errmsg:string;
        errmsg = Validation.checkPasswordRule(getRef(newPw), "パスワード")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            setSubmitDisabled(false);
            return false;
        }
        errmsg = Validation.checkCompare(getRef(newPw), getRef(confirmPw), "確認パスワード")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            setSubmitDisabled(false);
            return false;
        }
        
        //パスワード変更処理
        postApiDataWithToken('/management/settings/password',
            {'operator_id': cua.getOperatorNo(), 'password': getRef(currentPw), 'new_password': getRef(newPw)},
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:
                        setMsgArgs({type:mb.MSGBOX_TYPE_SUCCESS, text:"パスワードの設定が完了しました。"});
                        break;
                    case 400:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"現行のパスワードが一致しません。"});
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"パスワードの設定に失敗しました。"});
                }
                setSubmitDisabled(false);
            }
        );
        
    }

    return (
        <AdminFrame>
            <div className="contents">
                <mb.MessageBox args={msgArgs}/>
                <h2 className="settings-title-h2">パスワード設定</h2>
                <div className="settings-wrap-short">
                    <div className="settings-block">
                        <h3 className="settings-title-h3">パスワード</h3>
                        <div className="settings-form">
                        <div className="form-row">
                            <div className="form-row-title">現在のパスワード</div>
                            <div className="form-row-input"><input type="password" ref={currentPw}/></div>
                        </div>
                        <div className="form-row">
                            <div className="form-row-title">新しいパスワード</div>
                            <div className="form-row-comment">
                                8文字以上の英数字を入力してください。
                            </div>
                            <div className="form-row-input"><input type="password" ref={newPw}/></div>
                        </div>
                        <div className="form-row">
                            <div className="form-row-title">新しいパスワード（確認）</div>
                            <div className="form-row-input"><input type="password" ref={confirmPw}/></div>
                        </div>
                        </div>
                    </div>
                    <button className="btn-primary margin-tb-20" onClick={clickSubmit} disabled={submitDisabled}>変更を保存</button>
                </div>
            </div>
        </AdminFrame>
    )
}